import * as React from 'react';
import cx from 'classnames';
import style from './NextPage.css';
import {ButtonRound} from 'components/Button';
import substrate from '_images/shape.svg';
import IconArrow from './arrow.inline.svg';

export const NextPage = ({className, label, to}) => (
    <div className={cx(style.root, className)}>
        <img className={cx(style.substrate, 'rotation slower')} src={substrate}/>
        <ButtonRound className={style.button} to={to}>
            {label}
            <IconArrow className={style.arrow}/>
        </ButtonRound>
    </div>
);